var BaseView = require('../../../components/accordion-list/categories-director');
var CategoriesView = require('./stickers');

module.exports = BaseView.extend({
  class: 'sub-category stickers',
  CategoriesView: CategoriesView,
  views: {},

  loadButtons: function () {
    var deferred = $.Deferred();

    INKIVE.Tool.preloadStickerCategories(function () {
      var data = INKIVE.Tool._cache['stickerCategories'];
      deferred.resolve(_.map(data, function (stickersCategory) {
        return { key: stickersCategory.id, tag: stickersCategory.name, icon: 'fa fa-ellipsis-v' };
      }));
    });

    return deferred.promise();
  },

  initialize: function () {
    BaseView.prototype.initialize.call(this);
    this.render();
  }
});
